/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));

    theme.ShippingBar = (function () {
      const freeShippingWrapper = document.querySelectorAll('.shipping-bar-wrapper');
      const progressBarContainer = document.querySelectorAll('.shipping-bar-wrapper__container');
      const progressBar = document.querySelectorAll('.shipping-progress-bar');

      const { promote: promote_txt, unlocked: unlocked_txt, threshold } = freeShippingWrapper[0].dataset;

      const formatPrice = cents => `$${(cents / 100).toFixed(2)}`;

      function update() {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const amountUntilFreeShipping = threshold - cart.total_price;
            const percentOfThreshold = ((cart.total_price / threshold) * 100).toFixed(1);

            freeShippingWrapper.forEach((el, index) => {
              if (progressBar[index]) {
                progressBar[index].style.width = `${percentOfThreshold}%`;
              }

              if (progressBarContainer[index]) {
                if (percentOfThreshold >= 100) {
                  progressBarContainer[index].classList.add('hidden');
                } else {
                  progressBarContainer[index].classList.remove('hidden');
                }
              }

              if (amountUntilFreeShipping <= 0) {
                el.innerHTML = `<p>${unlocked_txt.replace('[value]', formatPrice(threshold))}</p>`;
              } else {
                el.innerHTML = `<p>${promote_txt.replace('[value]', formatPrice(amountUntilFreeShipping))}</p>`;
              }
            });
          })
          .catch(error => console.error('Error fetching cart:', error));
      }

      return { update: update };
    }());

    theme.ShippingBarCad = (function () {
      const freeShippingWrapperCad = document.querySelectorAll('.shipping-bar-wrapper-cad');
      const progressBarContainerCad = document.querySelectorAll('.shipping-bar-wrapper__container_cad');
      const progressBarCad = document.querySelectorAll('.shipping-progress-bar_cad');

      if (!freeShippingWrapperCad.length) {
        console.error("No CAD shipping bars found.");
        return;
      }

      const { promote, unlocked, threshold } = freeShippingWrapperCad[0].dataset;
      const threshold_cad = parseInt(threshold, 10);

      if (isNaN(threshold_cad)) {
        console.error("CAD Free Shipping Threshold is not a valid number:", threshold);
        return;
      }

      const formatPriceCad = (cents) => `$${(cents / 100).toFixed(2)}`;

      function update() {
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            const cartTotal = cart.total_price;
            const amountUntilFreeShipping = threshold_cad - cartTotal;
            const percentOfThresholdCad = ((cartTotal / threshold_cad) * 100).toFixed(1);

            freeShippingWrapperCad.forEach((el, index) => {
              if (progressBarCad[index]) {
                progressBarCad[index].style.width = `${percentOfThresholdCad}%`;
              }

              if (progressBarContainerCad[index]) {
                if (percentOfThresholdCad >= 100) {
                  progressBarContainerCad[index].classList.add('hidden');
                } else {
                  progressBarContainerCad[index].classList.remove('hidden');
                }
              }

              if (amountUntilFreeShipping <= 0) {
                el.innerHTML = `<p>${unlocked.replace('[value-cad]', formatPriceCad(threshold_cad))}</p>`;
              } else {
                el.innerHTML = `<p>${promote.replace('[value-cad]', formatPriceCad(amountUntilFreeShipping))}</p>`;
              }
            });
          })
          .catch((error) => console.error("Error fetching cart data:", error));
      }

      return { update: update };
    })();
  });

  document.addEventListener("DOMContentLoaded", function () { });
})();

document.addEventListener('DOMContentLoaded', function () {
  const countryCodeInput = document.querySelector('input[name="country_code"]');
  if (countryCodeInput) {
    const countryCode = countryCodeInput.value;

    document.getElementById('free-shipping-cad').classList.add('hidden');
    document.getElementById('free-shipping-usd').classList.add('hidden');

    if (countryCode === 'CA') {
      document.getElementById('free-shipping-cad').classList.remove('hidden');
    } else if (countryCode === 'US') {
      document.getElementById('free-shipping-usd').classList.remove('hidden');
    }
  }
});
const links = document.links;
 for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
   if (links[i].hostname !== window.location.hostname) {
     links[i].target = '_blank';
     links[i].rel = 'noreferrer noopener';
 }
}